const divElements = document.querySelectorAll(".hover-div");
// Cierra todos los elementos details abiertos
const closeList = () => {
  const openDetails = document.querySelectorAll("details[open]");
  openDetails.forEach((details) => {
    details.removeAttribute("open");
    const summaryElement = details.querySelector("summary");
    if (summaryElement) {
      summaryElement.setAttribute("aria-expanded", "false");
    }
  });
};
divElements.forEach((divElement) => {
  divElement.addEventListener("mouseover", function () {
    // Cierra todos los elementos details abiertos
    closeList();
    // Abre el elemento details correspondiente
    const detailsElement = this.querySelector("details");
    if (detailsElement) {
      detailsElement.setAttribute("open", "");
      const summaryElement = detailsElement.querySelector("summary");
      if (summaryElement) {
        summaryElement.setAttribute("aria-expanded", "true");
      }
    }
  });

  const megaMenuContent = divElement.querySelector('[id^="MegaMenu-Content-"]');

  if (megaMenuContent) {
    megaMenuContent.addEventListener("mouseout", function () {
      const detailsElement = this.closest("details");
      if (detailsElement) {
        detailsElement.removeAttribute("open");
        const summaryElement = detailsElement.querySelector("summary");
        if (summaryElement) {
          summaryElement.setAttribute("aria-expanded", "false");
        }
      }
    });
  }
});
// Cierra todos los elementos details abiertos cuando el mouse sale del header
const headerElement = document.querySelector("header");
headerElement.addEventListener("mouseleave", function () {
  closeList();
});
